export default __webpack_public_path__ + "static/blob14-6291f37b02c9f845a500a5841bd121bf.svg";